












































































import SharesService from "@/api/services/sharesService";
import { Component, Vue } from "vue-property-decorator";

interface TableItem {
  date: string;
  email: string;
  username: string;
  fileId: number;
}

@Component
export default class Home extends Vue {
  private sharesService = new SharesService(this);

  items: TableItem[] = [];
  loading = false;
  sortByColumn: string | null = null;
  sortAsc = false;

  async refresh() {
    this.loading = true;
    let usersResponce = await this.sharesService.users();
    if (usersResponce == null) {
      this.items = [];
      this.loading = false;
      return;
    }
    let users = usersResponce.data;
    let ids = users.map(u => u.id);
    let scans = await this.sharesService.scans(ids);
    if (scans == null) {
      this.items = [];
      this.loading = false;
      return;
    }
    let items = [];
    for (let scan of scans.data) {
      let item: TableItem = {
        date: scan.date_created,
        email: users.filter(u => u.id == scan.user_id)[0].email,
        username: users.filter(u => u.id == scan.user_id)[0].name,
        fileId: scan.id
      };
      items.push(item);
    }
    this.items = items;
    this.loading = false;
  }

  async downloadObj(item: TableItem) {
    let resp = await this.sharesService.objUrl(item.fileId);
    window.location.assign(resp.data.url);
  }

  async downloadCsv(item: TableItem) {
    const resp = await this.sharesService.csv(item.fileId);
    const download = item.email + '_' + this.formatDateForFile(item.date) + '.csv';

    const fileParts = [resp];
    const blob = new Blob(fileParts, {type : 'text/csv'});

    const blobUrl = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = download;

    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    window.URL.revokeObjectURL(blobUrl);
  }

  async mounted() {
    await this.refresh();
  }

  formatDate(date: string): string {
    let options: Intl.DateTimeFormatOptions = {
      hour12: true,
      hour: "2-digit",
      minute: "2-digit"
    };
    return new Date(date).toLocaleDateString("en-us", options);
  }

  formatDateForFile(dateString: string): string {
    const date = new Date(dateString);

    return [
      date.getFullYear(),
      (date.getMonth() + 1).toString().padStart(2, '0'),
      date.getDate().toString().padStart(2, '0'),
      ((date.getHours() % 12) ? date.getHours() % 12 : 12).toString().padStart(2, '0'),
      date.getMinutes().toString().padStart(2, '0'),
      date.getSeconds().toString().padStart(2, '0'),
      (date.getHours() < 12 ) ? "AM" : "PM"
    ].join('_');
  }

  get sortedItems() {
    if (this.sortByColumn != null) {
      if (this.sortByColumn == "date") {
        let items = this.items.sort((a, b) => {
          if (a.date < b.date) {
            return -1;
          }
          if (a.date > b.date) {
            return 1;
          }
          return 0;
        });
        if (!this.sortAsc) {
          items = items.reverse();
        }
        return items;
      } else if (this.sortByColumn == "email") {
        let items = this.items.sort((a, b) => {
          if (a.email < b.email) {
            return -1;
          }
          if (a.email > b.email) {
            return 1;
          }
          return 0;
        });
        if (!this.sortAsc) {
          items = items.reverse();
        }
        return items;
      }
    }
    return this.items;
  }

  sortBy(col: string) {
    if (this.sortByColumn == col) {
      this.sortAsc = !this.sortAsc;
    } else {
      this.sortAsc = false;
    }
    this.sortByColumn = col;
  }
}
